import { LitElement } from "lit-element";
import { html, render } from "lit-html";
import BdsGltfViewer from "../../bdsWebLib/3D/BdsGltfViewer";

class Ipc3dViewer extends LitElement {
  constructor() {
    super();
  }

  // called from parent component in CCB to ensure viewer does not 
  // start rendering loop before component is fully mounted on the DOM
  startViewer() {
    this.viewer = new BdsGltfViewer(this.hostRelativeUri);
    this.myRender();
    this.viewer.runEngineRenderLoop();
  }

  connectedCallback() {}

  myRender() {
    render(
      html`
        <style>
          #ipc-viewer-container {
            max-width: 1024px;
            overflow: hidden;
          }
        </style>
        <div id="ipc-viewer-container">
          ${this.viewer.create()}
        </div>
      `,
      this.shadowRoot
    );
  }
}

customElements.define("ipc-3d-viewer", Ipc3dViewer);
